import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { VdcDialogService } from '@prime/client/services/dialogs';
import { of } from 'rxjs';
import { AuthService } from '@prime/client/services/client-auth';
import { User } from '@prime/types';

@Injectable({ providedIn: 'root' })
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private dialogs: VdcDialogService, private _authService: AuthService) {}

  ctr: number = 0
  logout = true;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(response => {
        const isMulesoftOrMendixRequest = req && (req.url.includes('mulesoft') || req.url.includes('mendix'));

        if (response instanceof HttpErrorResponse && response.status === 401) {
          this.handleUnauthorizedError();
        } else if (response instanceof HttpErrorResponse) {
          console.error('ErrorInterceptor:intercept Server error: ',response);
          // Mulesoft/Mendix requests already get a detailed error dialog from the calling
          // component (with the real Mendix message) — showing this generic statusText
          // snackbar on top of that is just confusing noise.
          if (!isMulesoftOrMendixRequest) {
            this.dialogs.staticSnackBarMessage(response.statusText, 'Close');
          }
        }
        if (isMulesoftOrMendixRequest) {
          return throwError(response);
        } else {
          return of(null);
        }
      })
    );
  }

  private handleUnauthorizedError() {
    this.ctr++;
    if(this.ctr == 1){
      this._authService.getRefreshToken().subscribe({
        next: (user: User) => {
          this._authService.setTokens(user);
          location.reload();
          this.logout = false;
          return;
        },
        complete: () =>{
          if(this.logout){
            this._authService.logOut();
            location.reload();  
        }
        }
      });
    }
  }
}
